<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="50%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="单位名称" prop="CompanyID">
                <el-select
                    v-model="companyModel.SearchKey"
                    @change="handleSearchCompany"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入单位查询"
                    :remote-method="remoteMethod2"
                    :disabled="isdisabled"
                    >
                    <el-option
                        v-for="item in companyList"
                        :key="item.OID"
                        :label="item.Name"
                        :value="item.OID">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备编码" prop="DeviceCode">
                <el-input size="small" v-model="model.DeviceCode" auto-complete="off" placeholder="请输入设备编码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="设备名称" prop="DeviceName">
                <el-input size="small" v-model="model.DeviceName" auto-complete="off" placeholder="请输入设备名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="设备类型" prop="DeviceType">
                <el-radio-group v-model="model.DeviceType">
                    <el-radio label="web"></el-radio>
                    <el-radio label="android"></el-radio>
                    <el-radio label="dingding"></el-radio>
                    <el-radio label="windows"></el-radio>
                    <el-radio label="ios"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="产品名称" prop="ApplicationVersionName">
                <el-input size="small" v-model="model.ApplicationVersionName" auto-complete="off" placeholder="请输入应用名称及版本" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="出品单位" prop="ProducerNmae">
                <el-input size="small" v-model="model.ProducerNmae" auto-complete="off" placeholder="请输入公司名称" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {AddDevice} from '../../api/device'
import {GetCompanyList} from '../../api/company'
let validDevice = (rule, value, callback) => {
    let reg = /^[A-Za-z0-9]+$/;
    if (value === '') {
        callback(new Error('请输入设备唯一编码'));
    } else if(!reg.test(value)) {
        callback(new Error('设备编码只能是数字和字母'))
    } else {
        callback();
    }
};
export default {
    data() {
        return {
            title: '添加设备',
            name: 'add',
            isdisabled: false,
            companyList: [],
            model: {
                CompanyID: null, //单位ID
                DeviceName: '', //设备名称
                DeviceCode: '', //设备唯一编码
                DeviceType: 'web',// 类型可选项web, android, windows, ios
                ApplicationVersionName:'校阅通',
                ProducerNmae: '上海声阅智能科技有限公司'
            },
            companyModel: {
                Page: 1,
                Rows: 10,
                SearchKey: ''
            },
            rules: {
                CompanyID: [{ required: true, message: '请输入单位ID', trigger: 'blur' }],
                DeviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
                DeviceCode: [{ required: true,  trigger: 'blur',validator: validDevice}],
                DeviceType: [{ required: true, message: '请输入设备类型', trigger: 'blur' }],
                ApplicationVersionName: [{ required: true, message: '请输入应用名称及版本', trigger: 'blur' }],
                ProducerNmae: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        CompanyID: {
            required: true
        },
        companyName:{
            required: true,
            type: String
        }
    },  
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.model.CompanyID = this.CompanyID;
            this.companyModel.SearchKey = this.companyName;
        },
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.AddDevice()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeAddDialog')
        },
        AddDevice() {
            AddDevice(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
        GetCompanyList() {
            GetCompanyList(this.companyModel).then(data=>{
                if(!data.iserror) {
                    this.companyList = data.data.List;
                }
            })
        },
        handleSearchCompany(val) {
            this.model.CompanyID = val;
        },
        remoteMethod2(query) {
            this.companyModel.SearchKey = query;
            this.GetCompanyList();
        },
           
    }
}
</script>

<style>

</style>